import firebase from 'firebase'

const config={
    //apiKey: "AIzaSyDy_PcYafo0-N0zldiFmv4Efe4cgwh7_t8",
    //authDomain: "fir-mobileverification-f78bd.firebaseapp.com",
    //projectId: "fir-mobileverification-f78bd",
    //storageBucket: "fir-mobileverification-f78bd.appspot.com",
    //messagingSenderId: "133926781344",
    //appId: "1:133926781344:web:9bf33484a8b495cef864c5",
    //measurementId: "G-KCN6HTY7HY"
	
	
	apiKey: "AIzaSyBNWnlVXmGesQkEVPrmZAVZtmnIr7TTzUk",
    authDomain: "featsystemsiris.firebaseapp.com",
    projectId: "featsystemsiris",
    storageBucket: "featsystemsiris.appspot.com",
    messagingSenderId: "161124511176",
    appId: "1:161124511176:web:07c927c3d85de17ae5e4fd",
    measurementId: "G-01GT96PTSL"
}

firebase.initializeApp(config);
export default firebase
